import React from 'react';
import { StyledBannerTech } from './StyledBannerTech';

const BannerTech = ({ bgColor, text, route, copyRoute, black }) => {

  return (
    <React.Fragment>
      {
       
          <StyledBannerTech
            bgColor={bgColor}
          >
            <div className="banner-tech--content">
              <div className="banner-tech--content-col col--img">
                <img src={require('../../assets/banner-tech.png')} />
              </div>
              <div className="banner-tech--content-col col--text">
                <h5 className="big--title" style={{color: black ? black : 'inherit'}}>
                  Want to know more about the tech side?
                </h5>
                <div className="cta--primary cursor-cta">
                  <p className="preset-10 cursor-cta" style={{color: black ? black : '#003D2B'}} >Go to tech</p>
                  
                  <svg width="14" className="next cursor-cta" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path className="cursor-cta" d="M7.66675 10.6673L13.0001 6.00065L7.66675 1.33398" stroke={black ? black : '#003D2B'} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                    <path className="cursor-cta" d="M13 6H1" stroke={black ? black : '#003D2B'} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
            </div>
            
          </StyledBannerTech>
          
      }
    </React.Fragment>
  );
};

BannerTech.propTypes = {};

BannerTech.defaultProps = {
  tag: "div",
  bgColor: "#fff"
};

export default BannerTech;
